import { type ProductizedServiceCardDetails_productizedService$key } from '#app/__generated__/relay/ProductizedServiceCardDetails_productizedService.graphql.js';
import { Text } from '#app/components/Primitives/Text.js';
import { ProductizedServiceCardExampleProjects } from './ProductizedServiceCardExampleProjects.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;

    ${theme.mediaQueries.lg} {
      padding: 24px;
    }
  `}
`;

const Title = styled(Text)`
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type ProductizedServiceCardDetailsProps = {
  readonly productizedServiceRef: ProductizedServiceCardDetails_productizedService$key;
};

export const ProductizedServiceCardDetails = ({
  productizedServiceRef,
}: ProductizedServiceCardDetailsProps) => {
  const service =
    useFragment<ProductizedServiceCardDetails_productizedService$key>(
      graphql`
        fragment ProductizedServiceCardDetails_productizedService on ProductizedService {
          title
          ...ProductizedServiceCardExampleProjects_productizedService
        }
      `,
      productizedServiceRef,
    );

  return (
    <Container>
      <Title textStyle="sixthLevelHeadline">{service.title}</Title>
      <ProductizedServiceCardExampleProjects productizedServiceRef={service} />
    </Container>
  );
};
